import { authContext } from '../adalConfig';

export const logOut = () => {
	window.sessionStorage.clear();
	window.localStorage.clear();
	authContext.clearCache();
    authContext.logOut();
};